var React = require('react');

function CaretUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.26263 18.9646C-0.0297405 18.9646 -0.398989 17.7646 0.47798 16.7953L10.4016 5.8101C11.2785 4.84082 12.7555 4.74851 13.6325 5.71779L23.5099 16.8414C24.3869 17.8107 24.0638 18.9646 22.7253 18.9646L1.26263 18.9646Z","fill":"currentColor"}));
}

CaretUp.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = CaretUp;

CaretUp.default = CaretUp;
